import { palette } from "lib/miolo";
import FundamentalsChartContext from "components/fundamentals/FundamentalsChartContext";
import { Fundaments } from "components/fundamentals/Fundaments";
import FundamentToggle from "components/fundamentals/FundamentToggle";

export default function BankFundamentalsToggles() {
  return (
    <FundamentalsChartContext.Consumer>
      {({ fundaments, toggle, selectOnly, selectableFundaments }) => (
        <>
          <FundamentToggle
            labelText="Patrim. Líq."
            labelTextColor={palette.kumera}
            backgroundColor={palette.linen}
            isActive={fundaments.includes(Fundaments.NET_EQUITY)}
            onClick={() => toggle(Fundaments.NET_EQUITY)}
            onDoubleClick={() => selectOnly(Fundaments.NET_EQUITY)}
          />

          <FundamentToggle
            labelText="Receita Líq."
            labelTextColor={palette.fruitSalad}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.FINANCIAL_INTERMEDIATION_REVENUE)}
            onClick={() => toggle(Fundaments.FINANCIAL_INTERMEDIATION_REVENUE)}
            onDoubleClick={() => selectOnly(Fundaments.FINANCIAL_INTERMEDIATION_REVENUE)}
          />

          <FundamentToggle
            labelText="Lucro Líq."
            labelTextColor={palette.oceanGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_INCOME)}
            onClick={() => toggle(Fundaments.NET_INCOME)}
            onDoubleClick={() => selectOnly(Fundaments.NET_INCOME)}
          />

          <FundamentToggle
            labelText="Mrg. Líq."
            labelTextColor="#507712"
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_MARGIN)}
            onClick={() => toggle(Fundaments.NET_MARGIN)}
            onDoubleClick={() => selectOnly(Fundaments.NET_MARGIN)}
          />

          {selectableFundaments.includes(Fundaments.RETURN_ON_EQUITY) && (
            <FundamentToggle
              labelText="ROE"
              labelTextColor={palette.stromboli}
              backgroundColor="#EEFBEF"
              isActive={fundaments.includes(Fundaments.RETURN_ON_EQUITY)}
              onClick={() => toggle(Fundaments.RETURN_ON_EQUITY)}
              onDoubleClick={() => selectOnly(Fundaments.RETURN_ON_EQUITY)}
            />
          )}

          <FundamentToggle
            labelText="PDD"
            labelTextColor={palette.mojo}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.PROVISION_FOR_CREDIT_LOSSES)}
            onClick={() => toggle(Fundaments.PROVISION_FOR_CREDIT_LOSSES)}
            onDoubleClick={() => selectOnly(Fundaments.PROVISION_FOR_CREDIT_LOSSES)}
          />

          {selectableFundaments.includes(Fundaments.CASH_FLOW_FOR_DIVIDENDS) && (
            <FundamentToggle
              labelText="Proventos"
              labelTextColor={palette.luxorGold}
              backgroundColor="#FCF9F0"
              isActive={fundaments.includes(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
              onClick={() => toggle(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
              onDoubleClick={() => selectOnly(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
            />
          )}

          <FundamentToggle
            labelText="Payout"
            labelTextColor="#CB6E17"
            backgroundColor="#FCF9F0"
            isActive={fundaments.includes(Fundaments.PAYOUT)}
            onClick={() => toggle(Fundaments.PAYOUT)}
            onDoubleClick={() => selectOnly(Fundaments.PAYOUT)}
          />
        </>
      )}
    </FundamentalsChartContext.Consumer>
  );
}
